import { useSelector } from 'react-redux';
import { selectShowInvalids, selectOrderedUnitsIsEmpty } from '@store/partners-order/selectors';
import DogsSizesGrid from '@pages/partners-order/sizes-units/DogsSizesGrid';
import CatsCollarSizesGrid from '@pages/partners-order/sizes-units/CatsCollarSizesGrid';
import CatsSizesGrid from '@pages/partners-order/sizes-units/CatsSizesGrid';


const SizesUnits = (): JSX.Element => {

	const showInvalids = useSelector(selectShowInvalids);
	const orderedUnitsIsEmpty = useSelector(selectOrderedUnitsIsEmpty);

	return (
		<div className='sizes-units-section'>

			<div className='dogs-sizes'>
				<label className='units-label'>
					Pooperační límce pro&nbsp;psy {showInvalids && orderedUnitsIsEmpty &&
						<p className='form-invalid'>U psa nebo u kočky vyberte alespoň nějaké položky</p>}
				</label>

				<p>Velikost</p>

				<DogsSizesGrid />
			</div>

			
			<div className='cats-sizes'>
				<label className='units-label'>
					Pooperační límce pro&nbsp;kočky
				</label>

				<p>Velikost</p>

				<CatsCollarSizesGrid />
			</div>

			
			<div className='cats-sizes'>
				<label className='units-label'>
					GASTRO límec jícnová sonda pro&nbsp;kočky
				</label>

				<p>Velikost</p>

				<CatsSizesGrid />
			</div>

			<p className='test-samples-warning'>* SADA OBSAHUJE VŠECHNY VELIKOSTI GASTRO LÍMCŮ ZA ZVÝHODNĚNOU CENU, PLATÍ POUZE V PŘÍPADĚ PRVNÍ OBJEDNÁVKY</p>

		</div>
	);
};

export default SizesUnits;